// Utility functions for language handling

export type Language = 'en' | 'et' | 'ru' | 'fi';

/**
 * Maps language codes to URL prefixes
 * Estonian uses 'ee' in URLs but 'et' internally
 */
export const getUrlPrefix = (language: Language): string => {
  if (language === 'et') {
    return 'ee';
  }
  return language;
};

/**
 * Maps URL prefixes to internal language codes
 */
export const getLanguageFromUrlPrefix = (prefix: string): Language | null => {
  if (prefix === 'ee') {
    return 'et';
  }
  if (prefix === 'en' || prefix === 'ru' || prefix === 'fi') {
    return prefix as Language;
  }
  return null;
};